import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { servicios } from "../../json/servicios";
import { sinternos_item } from "../../json/servicios";
import "./servicios.css";

const Servicios = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const linkStyle = {
    textDecoration: "none",
  };

  return (
    <div className="container servicios-container">
      <div className='row'>
            <div className='col_12'>
                <div className='servicios_title'>
                    <h1>Servicios</h1>
                </div>
            </div>
        </div>
      <div className="row">        
        {servicios.map((item, index) => (
          
          <Link style={linkStyle} to={item.enlace} className='col-md-4 col-sm-6 col-12'>
          <div className="col -md-4">
            <div className="card">
              <div className="card-body">
                <h6 className=".servicios_title"> {item.nombre} </h6>
                <div className="btn_agenda"></div>
              </div>
            </div>
          </div>
          </Link>
         
        ))}
      </div>
      <hr className='hr-gob'/>
      <div className="row">
        <div className="col_12">
          <div className="transparencia_title">
            <h1>Servicos Internos</h1>
          </div>
        </div>
      </div>
      <div className="row">
        {sinternos_item.map((item, index) => (
          <>
            <div key={index} className="col-md-4">
              <Link  style={linkStyle} to={item.sinternos_item_url}>
                <div className="card">
                  <div className="card-body">
                    <div className="sec_transparencia">
                      <h5>{item.sinternos_item_nombre}</h5>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
          </>
        ))}
      </div>
    </div>
  );
};

export default Servicios;
